import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import styles from './Layout.module.scss';
import { Row } from './Row';
export const FullRow = (_0)=>{
    let { className, children, centered = false } = _0, rest = _object_without_properties(_0, [
        "className",
        "children",
        "centered"
    ]);
    return /*#__PURE__*/ _jsx(Row, _object_spread_props(_object_spread({
        className: cn(styles.fullRow, {
            [styles.centered]: centered
        }, className)
    }, rest), {
        children: children
    }));
};
